import { useEffect, useState } from "react";

import { useSlate } from "slate-react";
import { Dropdown, DropdownButton } from "react-bootstrap";

import { TEXT_ALIGN_TYPES } from "../../constants";
import { isBlockActive, toggleBlock } from "../../utils/utility";

const formats = [
  {
    value: "paragraph",
    label: "Normal Text",
    element: <span>Normal Text</span>,
  },
  {
    value: "heading-one",
    label: "Heading 1",
    element: (
      <h1 className="p-0 m-0">
        <small>Heading 1</small>
      </h1>
    ),
  },
  {
    value: "heading-two",
    label: "Heading 2",
    element: (
      <h2 className="p-0 m-0">
        <small>Heading 2</small>
      </h2>
    ),
  },
  {
    value: "heading-three",
    label: "Heading 3",
    element: (
      <h3 className="p-0 m-0">
        <small>Heading 3</small>
      </h3>
    ),
  },
  {
    value: "heading-four",
    label: "Heading 4",
    element: (
      <h4 className="p-0 m-0">
        <small>Heading 4</small>
      </h4>
    ),
  },
  {
    value: "heading-five",
    label: "Heading 5",
    element: (
      <h5 className="p-0 m-0">
        <small>Heading 5</small>
      </h5>
    ),
  },
  {
    value: "heading-six",
    label: "Heading 6",
    element: (
      <h6 className="p-0 m-0">
        <small>Heading 6</small>
      </h6>
    ),
  },
];

const HeadingFormat = () => {
  const editor = useSlate();
  const activeIndex = formats.findIndex((format) =>
    isBlockActive(
      editor,
      format.value,
      TEXT_ALIGN_TYPES.includes(format.value) ? "align" : "type",
    ),
  );
  const [active, setActive] = useState(
    formats[activeIndex >= 0 ? activeIndex : 0],
  );

  useEffect(() => {
    setActive(formats[activeIndex >= 0 ? activeIndex : 0]);
  }, [activeIndex]);

  return (
    <DropdownButton
      id={`dropdown-variants`}
      className="min-width-120"
      variant="light"
      size="sm"
      title={active?.label}
      setActive={setActive}
    >
      {formats.map((format, index) => (
        <Dropdown.Item
          key={index}
          active={active.value === format.value}
          onClick={(event) => {
            event.preventDefault();
            setActive(format);
            toggleBlock(editor, format.value);
          }}
        >
          {format.element}
        </Dropdown.Item>
      ))}
    </DropdownButton>
  );
};

export default HeadingFormat;
